export const AdminUserActionConstants = {
    SET_ADMINUSERS: 'SET_ADMINUSERS',
    ADD_ADMINUSER: 'ADD_ADMINUSER',
    UPDATE_ADMINUSER: 'UPDATE_ADMINUSER',
    DELETE_ADMINUSER: 'DELETE_ADMINUSER',
    STORE_ADMINUSERS: 'STORE_ADMINUSERS',
    FETCH_ADMINUSERS: 'FETCH_ADMINUSERS',
}